
<div class="cm-landing-fixed-width cm-hero-section">
	<h1>
		Contact US
	</h1>
	<p>
		Have a question about CropManage? Send us a note and we'll get 
		back to you.
	</p>
</div>

<div class="cm-landing-fixed-width cm-form">
	<form [formGroup]="form">
		<mat-form-field
			appearance="fill">
			<mat-label>{{ 'Name' | translate }}</mat-label>
			<input matInput 
				formControlName="FullName"
				required>
		</mat-form-field>

		<mat-form-field
			appearance="fill">
			<mat-label>{{ 'Email' | translate }}</mat-label>
			<input matInput 
				type="email"
				formControlName="Email"
				required>
		</mat-form-field>
		<mat-form-field class="hp"
			appearance="fill">
			<mat-label>{{ 'Company' | translate }}</mat-label>
			<input matInput 
				type="text"
				autocomplete="off"
				formControlName="Company">
		</mat-form-field>
		<mat-form-field
			appearance="fill">
			<mat-label>{{'Topic Category' | translate }}</mat-label>
			<mat-select required
				formControlName="TopicId">
				<mat-option *ngFor="let topic of topics"
					[value]="topic.Id">
					{{topic.Name | translate }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="fill">
			<mat-label>Your message</mat-label>
			<textarea matInput
				formControlName="Message" rows="5">
			</textarea>
		</mat-form-field>
		<button [disabled]="!form.valid"
			(click)="submit()"
			class="cm-view-full-list-button">
			{{ (isProcessing ? 'Sending Message' : 'Send Message') | translate }}
			<img class='bk-button__loader' *ngIf='isProcessing'
			src='/assets/images/loader-20px.gif'/>
		</button>
		<p>
			We use your info only to respond to your message.
		</p>
	</form>
</div>